export default __webpack_public_path__ + "static/media/Zasway-Logo.47aa1e8d.png";